export enum FieldTypeEnum {
  INPUT_MULTI_SELECT,
  INPUT_TEXT,
  INPUT_SELECT,
}
